// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1ZxNf","containerItemsCenter":"Skeleton_containerItemsCenter__3wsE3"};